import type { IMetadata } from '@adloid-technologies/discover-sdk';

/**
 * Groove Configurator (linkId 2386).
 *
 * Converted from the 1.0 repo's `src/metadata/data/metadata-2386.ts`
 * (`appData.visualiser.models[0]`, array-shaped) into the 2.0 object-keyed
 * `IMetadata` shape. Generated — see the conversion notes in ui-metadata.ts.
 */
export const metadata: IMetadata = {
  models: {
    Groove: {
      id: 'Groove',
      lightingIdentifier: {
        interior: 'dome',
        exterior: 'dome'
      },
      postProcessingIdentifier: {
        interior: 'dome',
        exterior: 'dome'
      },
      backgroundIdentifer: 'dome',
      variants: {
        'rs-fwd': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '6621',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '6626',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '6611',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'common_interior',
              sku: '6613',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '5526',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'lt-fwd': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '6621',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '6618',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '6611',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'common_interior',
              sku: '6613',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '5526',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        }
      },
      backgrounds: {
        g0ZA968_RpUd: {
          isDefault: false,
          sku: '5457',
          project: '59'
        },
        g0ZA968_RpUe: {
          isDefault: true,
          sku: '5526',
          project: '59'
        }
      },
      ambientLighting: {
        ambientColors: '',
        ambientLightings: {},
        relevantVariants: []
      },
      colors: {
        interior: {
          bmbnnt678r0o: {
            sku: '6626',
            project: '59',
            relevantVariants: [
              'rs-fwd'
            ],
            notCompatibleExteriorColors: []
          },
          'bmbnnt678r0o-2': {
            sku: '6618',
            project: '59',
            relevantVariants: [
              'lt-fwd'
            ],
            notCompatibleExteriorColors: []
          }
        },
        exterior: {
          k550ufl2z63j: {
            sku: '6611',
            project: '59',
            relevantVariants: [
              'rs-fwd'
            ]
          },
          'k550ufl2z63j-2': {
            sku: '6611',
            project: '59',
            relevantVariants: [
              'lt-fwd'
            ]
          },
          gxqxsxnaljfj: {
            sku: '6612',
            project: '59',
            relevantVariants: [
              'rs-fwd'
            ]
          },
          'gxqxsxnaljfj-2': {
            sku: '6612',
            project: '59',
            relevantVariants: [
              'lt-fwd'
            ]
          },
          '9i25yo15msgi': {
            sku: '6627',
            project: '59',
            relevantVariants: [
              'rs-fwd'
            ]
          },
          '9i25yo15msgi-2': {
            sku: '6627',
            project: '59',
            relevantVariants: [
              'lt-fwd'
            ]
          },
          l415icrduyfe: {
            sku: '6631',
            project: '59',
            relevantVariants: [
              'rs-fwd'
            ]
          },
          'l415icrduyfe-2': {
            sku: '6631',
            project: '59',
            relevantVariants: [
              'lt-fwd'
            ]
          },
          t0ah6d0ze4xe: {
            sku: '6616',
            project: '59',
            relevantVariants: [
              'rs-fwd'
            ]
          },
          't0ah6d0ze4xe-2': {
            sku: '6616',
            project: '59',
            relevantVariants: [
              'lt-fwd'
            ]
          },
          ew6nnknehod1: {
            sku: '6615',
            project: '59',
            relevantVariants: [
              'rs-fwd'
            ]
          },
          'ew6nnknehod1-2': {
            sku: '6615',
            project: '59',
            relevantVariants: [
              'lt-fwd'
            ]
          }
        }
      },
      features: {
        ylam62d7djz9: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rs-fwd'
          ],
          messages: [
            {
              message: 'SHADER_Bumper',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Bumper',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        'ylam62d7djz9-2': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-fwd'
          ],
          messages: [
            {
              message: 'SHADER_Bumper',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Bumper',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        kh1xk6tsachv: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rs-fwd'
          ],
          messages: [
            {
              message: 'SHADER_Front_Bowtie',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front_Bowtie',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        'kh1xk6tsachv-2': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-fwd'
          ],
          messages: [
            {
              message: 'SHADER_Front_Bowtie',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front_Bowtie',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '1slkxz7syxvp': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rs-fwd'
          ],
          messages: [
            {
              message: 'Alloy',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Alloy_17',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '1slkxz7syxvp-2': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-fwd'
          ],
          messages: [
            {
              message: 'Alloy',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Alloy_16',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        kbns5f4ez323: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rs-fwd'
          ],
          messages: [
            {
              message: 'SHADER_Headlmaps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlmaps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        'kbns5f4ez323-2': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-fwd'
          ],
          messages: [
            {
              message: 'SHADER_Headlmaps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlmaps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        k1gebz2rhrfs: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rs-fwd'
          ],
          messages: [
            {
              message: 'Roof',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '511hi24a2yfb': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rs-fwd'
          ],
          messages: [
            {
              message: 'SHADER_Sunroof',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Roof',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        dk4jj9hgugds: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rs-fwd'
          ],
          messages: [
            {
              message: 'SHADER_Roof',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Roof',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        y6zcqp9r8fln: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rs-fwd'
          ],
          messages: [
            {
              message: 'SHADER_Infoscreen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Infoscreen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        'y6zcqp9r8fln-2': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-fwd'
          ],
          messages: [
            {
              message: 'SHADER_Infoscreen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Infoscreen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        xsdac8nojc1s: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rs-fwd'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        'xsdac8nojc1s-2': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-fwd'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        ddlwz0n6pzn8: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rs-fwd'
          ],
          messages: [
            {
              message: 'Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        'ddlwz0n6pzn8-2': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-fwd'
          ],
          messages: [
            {
              message: 'Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        }
      },
      accessories: {
        wdbc64xihtb2: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'EXT_RS_Variant',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rs-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wdbqc64xihtb2: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'EXT_LT_Variant',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wdblc644xihtb2: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Alloy_PWS_17_inch',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wdblc064x8ihtb2: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Electronic_Brake',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        }
      },
      packages: {},
      interactions: {
        xbdzchklx04d: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'rs-fwd',
            'lt-fwd'
          ]
        },
        '9a4ewd0iqpwk': {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rs-fwd',
            'lt-fwd'
          ]
        },
        fwou2afhghpp: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SUNROOF_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SUNROOF_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 4.7123,
                beta: 1.6118,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'rs-fwd'
          ]
        },
        bkr8amy2tvbs: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rs-fwd',
            'lt-fwd'
          ]
        },
        '6146uzbd6kui': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rs-fwd'
          ]
        },
        iq7p37hq4g0j: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rs-fwd',
            'lt-fwd'
          ]
        },
        z1338jyjvioh: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'FOG_GLOW',
              identifiers: [
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'FOG_GLOW',
              identifiers: [
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rs-fwd',
            'lt-fwd'
          ]
        }
      },
      hotspots: {
        exteriorCamera: {
          type: 'exterior',
          messages: {
            fov: 0.8,
            alpha: 2.02,
            beta: 1.47,
            radius: 5.7,
            upperRadiusLimit: 6.7,
            lowerRadiusLimit: 3.2,
            lowerBetaLimit: 0.1,
            upperBetaLimit: 1.6,
            lowerAlphaLimit: null,
            upperAlphaLimit: null,
            target: {
              x: 0,
              y: 0.65,
              z: 0
            },
            isFovZoomModeOn: false
          }
        },
        interiorCamera: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA',
            identifiers: [
              'common_exterior'
            ]
          }
        },
        interiorCamera_1: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA_2',
            identifiers: [
              'common_exterior'
            ]
          }
        },
        interiorCamera_2: {
          type: 'interior',
          messages: {}
        }
      },
      usdzPathWithVariable: ''
    }
  }
};
